export default "__VITE_ASSET__CCbdYBmS__"